<div class="sgt-produtividade-classificacoes-kpi-widget card card-widget">
    <div class="card-header">
        <h6 class="card-title">
            {{title}}
        </h6>
        <small class="card-subtitle" *ngIf="subtitle">
            {{subtitle}}
        </small>
    </div>

    <div class="card-body" *ngIf="isLoading$ | async">
        <i class='fas fa-spinner fa-pulse'></i> Carregando
    </div>    

    <div class="container-navs" *ngIf="!(isLoading$ | async)">
        <ng-template [ngIf]="state?.data">
            <ul class="nav nav-tabs">
                <li class="nav-item" *ngFor="let tipoClassificacao of state.data.tiposClassificacoes; let first = first">
                    <a class="nav-link" [class.active]="first" [attr.data-target]="'#produtividadeClassificacoesKPIWidget_'+ tipoClassificacao.id" data-toggle="tab" (click)="onTabClick(tipoClassificacao)">
                        {{tipoClassificacao.nome}}
                    </a>
                </li>                                                  
            </ul> 
            <div class="tab-content">
                <div class="tab-pane" *ngFor="let tipoClassificacao of state.data.tiposClassificacoes; let first = first" [class.active]="first" id="produtividadeClassificacoesKPIWidget_{{tipoClassificacao.id}}">
                    <sgt-produtividade-classificacoes-kpi-table
                        #table
                        idDataTable="produtividadeClassificacaoKPITable_{{tipoClassificacao.id}}"
                        [tipoClassificacao]="tipoClassificacao"
                        [periodicidade]="state?.periodicidade">
                    </sgt-produtividade-classificacoes-kpi-table>
                </div>
            </div>                       
        </ng-template>
    </div>
</div>